var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.0002C26.2132 25.0002 31.25 20.1499 31.25 14.1668C31.25 8.18374 26.2132 3.3335 20 3.3335C13.7868 3.3335 8.75 8.18374 8.75 14.1668C8.75 20.1499 13.7868 25.0002 20 25.0002Z",
    fill: "#0D236E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.5284 22.5329L12.5117 34.8329C12.5117 36.3329 13.5617 37.0662 14.8617 36.4496L19.3284 34.3329C19.695 34.1496 20.3117 34.1496 20.6784 34.3329L25.1617 36.4496C26.445 37.0496 27.5117 36.3329 27.5117 34.8329V22.2329",
    fill: "#0D236E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.9a679f7cf8140bbe0148cf12d4ade187.svg";
export { ForwardRef as ReactComponent };